import {Component, Input} from '@angular/core';
import {AbstractComponent, ConfirmationModalComponent} from "@components";
import {AuthenticationService, ExportService, LeagueService, LoaderService, ToastService} from "@services";
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, Router} from "@angular/router";
import {FindEventsRequest, League, Lookups, TOAST_STATE} from "@model";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ADD, EDIT} from "../../../../../app-routing.module";

@Component({
  selector: 'app-list-of-leagues-statements',
  templateUrl: './list-of-leagues.component.html',
  styleUrls: ['./list-of-leagues.component.scss']
})
export class ListOfLeaguesComponent extends AbstractComponent {
  @Input() leagues: League[] = [];
  @Input({required: true}) languages: Lookups[] = [];

  constructor(private toastService: ToastService, private translocoService: TranslocoService, private router: Router,
              private leagueService: LeagueService, private loaderService: LoaderService,
              public authService: AuthenticationService, private modalService: NgbModal,
              private route: ActivatedRoute, private exportService: ExportService
  ) {
    super();
  }

  goToLeagueDetails(league: League): void {
    if (league && league.id) {
      this.router.navigate([EDIT], {queryParams: {leagueId: league.id}, relativeTo: this.route});
    }
  }

  openDeleteLeagueDialog(league: League): void {
    const modalRef: NgbModalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.title = this.translocoService.translate("leagues.delete.dialog.title");
    modalRef.componentInstance.text = this.translocoService.translate("leagues.delete.dialog.text");

    modalRef.result.then((_) => {
      this.deleteLeague(league);
    }, (_) => {
      /// ignore
    });
  }

  downloadLeagues(type: string) {
    this.exportService.downloadLeagues(type, this.createFilter());
  }

  createFilter() {
    return FindEventsRequest.createEventPageFilter(
      0,
      {
        dateFrom: undefined,
        dateTo: undefined,
        sport: undefined,
        selectedMonth: undefined,
      });
  }

  deleteLeague(league: League): void {
    this.loaderService.startLoading();
    this.leagueService.deleteLeague(league, () => {
      this.leagueService.findLeagues().subscribe((leagues: League[]): void => {
        this.leagues = leagues;
        this.loaderService.dismissLoading();
        this.toastService.showToast(TOAST_STATE.success,
          this.translocoService.translate("leagues.delete.success"));
      });
    }, () => {
      this.loaderService.dismissLoading();
      this.toastService.showToast(TOAST_STATE.danger,
        this.translocoService.translate("leagues.delete.error"));
    });
  }

  goToAddLeague(): void {
    this.router.navigate([ADD], {relativeTo: this.route});
  }
}
